import { render, staticRenderFns } from "./knowledge2.vue?vue&type=template&id=14136962&scoped=true"
import script from "./knowledge2.vue?vue&type=script&lang=js"
export * from "./knowledge2.vue?vue&type=script&lang=js"
import style0 from "./knowledge2.vue?vue&type=style&index=0&id=14136962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14136962",
  null
  
)

export default component.exports